import React from "react";


import { debounce, servicePick } from "utils";
import { FlexGrid, FlexGridItem } from "components/base/FlexGrid";


import { Checkbox, Form, Input, SelectPicker } from "rsuite";

export default (
    {
        service,
        filter = {},
        destinationList,
        subdestinationList,
        onChangeFilter,
    }
) => {

    const strPlaceholder = servicePick(service, "Filter per number or dialer name", "Filter per number");

    return (
        <Form
            formDefaultValue={filter}
            onChange={debounce((value) => {
                onChangeFilter(value);
            }, 1000)}
        >
            <FlexGrid align="middle">
                <FlexGridItem>
                    <Form.Control
                        accepter={Input}
                        name={"str"}
                        placeholder={strPlaceholder}
                        style={{ width: 300 }}
                    />
                </FlexGridItem>
                <FlexGridItem>
                    <Form.Control
                        accepter={SelectPicker}
                        data={destinationList}
                        name={"de_key"}
                        placeholder={"Destination"}
                        valueKey="de_key"
                        labelKey="name"
                        style={{ width: 224 }}
                    />
                </FlexGridItem>
                <FlexGridItem>
                    <Form.Control
                        accepter={SelectPicker}
                        data={subdestinationList}
                        name={"sde_key"}
                        placeholder={"Subdestination"}
                        valueKey="sde_key"
                        labelKey="name"
                        style={{ width: 224 }}
                    />
                </FlexGridItem>
                <FlexGridItem>
                    <Form.Control
                        accepter={CustomCheckbox}
                        name={"show_allocated_numbers"}
                    >
                        Show allocated numbers
                    </Form.Control>
                </FlexGridItem>
                <FlexGridItem>
                    <Form.Control
                        accepter={CustomCheckbox}
                        name={"show_unallocated_numbers"}
                    >
                        Show free numbers
                    </Form.Control>
                </FlexGridItem>
                <FlexGridItem>
                    <Form.Control
                        accepter={CustomCheckbox}
                        name={"show_test_numbers"}
                    >
                        Show test numbers
                    </Form.Control>
                </FlexGridItem>
                <FlexGridItem>
                    <Form.Control
                        accepter={CustomCheckbox}
                        name={"show_block_allocation_numbers"}
                    >
                        Show blocked numbers
                    </Form.Control>
                </FlexGridItem>
            </FlexGrid>
        </Form>
    );
};


const CustomCheckbox = ({ children, value = false, onChange, ...props }) => {
    return <Checkbox
        {...props}
        checked={!!value}
        onChange={(_, checked) => {
            onChange(checked);
        }}
    >
        {children}
    </Checkbox>
};
